import './App.scss';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { Redirect } from 'react-router';
import { Route, Switch, withRouter } from 'react-router-dom';
import '_scss/04-objects/_objects.flex.scss';
// import EmailOptin from './containers/email-optin/EmailOptin';
// import Address from './containers/address/Address';
import BasePage from './components/base-page/basepage';
import About from './containers/about/About';
import Fitting from './containers/fitting/Fitting';
import Home from './containers/home/Home';
import LaunchingRocket from './containers/launching-rocket/LaunchingRocket';
import Rating from './containers/rating/Rating';
import Result from './containers/result/Result';
import Start from './containers/start/Start';
import Testers from './containers/testers/Testers';
import Universe from './containers/universe/Universe';
import '_scss/main.scss';
import { translationMessages } from './i18n';
import {
  ROUTE_ABOUT,
  ROUTE_FITTING,
  ROUTE_HOME,
  ROUTE_LAUNCHING_ROCKET,
  ROUTE_LOGIN,
  ROUTE_RATING,
  ROUTE_RESULT_DETAIL,
  ROUTE_SPORTS_UNIVERSE,
  ROUTE_START,
  ROUTE_TESTERS,
  ROUTE_SINGAPORE_FINISHED
} from './RouteList';
import Login from './containers/login/Login';
import SingaporeFinished from './containers/singaporefinished/SingaporeFinished';

@inject('routing', 'dataStore')
@observer
class App extends React.Component<any, any> {
  public render() {
    const { dataStore } = this.props;
    return (
      <IntlProvider
        locale={dataStore.locale}
        messages={translationMessages[dataStore.locale]}
      >
        <BasePage isPrivate={dataStore.isPrivate}>
          <Switch>
            {!dataStore.isSingaporePrivate && (
              <Route path={ROUTE_HOME} component={Home} exact />
            )}
            {dataStore.isSingaporePrivate && (
              <Route path={ROUTE_LOGIN} component={Login} />
            )}

            <Route path={ROUTE_START} component={Start} />
            <Route path={ROUTE_RATING} component={Rating} />
            <Route path={ROUTE_FITTING} component={Fitting} />
            <Route
              path={ROUTE_SINGAPORE_FINISHED}
              component={SingaporeFinished}
            />
            <Route path={ROUTE_LAUNCHING_ROCKET} component={LaunchingRocket} />
            <Route path={ROUTE_SPORTS_UNIVERSE} component={Universe} />
            <Route path={ROUTE_RESULT_DETAIL} component={Result} />
            <Route path={ROUTE_ABOUT} component={About} />
            <Route path={ROUTE_TESTERS} component={Testers} />
            {/* <Route path={`/${ROUTE_EMAIL}`} component={EmailOptin} />
          <Route path={`/${ROUTE_ADDRESS}`} component={Address} /> */}

            <Redirect
              to={dataStore.isSingaporePrivate ? ROUTE_LOGIN : ROUTE_HOME}
            />
          </Switch>
        </BasePage>
      </IntlProvider>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.tsx